/*
 * components/CallComponent/DeviceUnavailableDialog.ts
 * Anvilo, Inc.
 *
 * This is a modal loading dialog which appears when an audio device is unavailable
 *
 * Created by Artem Yefimenko on 12/05/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import React from "react";

import ConfirmModal from "./modal/ConfirmModal";

import uiString from "../constants/uiString";

function DeviceUnavailableDialog({ onButtonClick }) {
  return (
    <ConfirmModal
      title={uiString.noDeviceAvailableModal.TITLE}
      desc={uiString.noDeviceAvailableModal.DESC}
      buttonLabel={uiString.OK}
      clickActionCallback={onButtonClick}
    />
  );
}

export default DeviceUnavailableDialog;
